export default __webpack_public_path__ + "static/media/Shopping.fdff8b4d.svg";